import { makeStyles } from '@material-ui/core';
import { Theme, Text } from '@bizzabo/design-system';

const EmptyView: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Text variant="t40" className={classes.mainText}>
                No conversations yet.
            </Text>
            <Text variant="t50" className={classes.subText}>
                Be the first to start one!
            </Text>
        </div>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        mainText: {
            padding: '0 16px',
            textAlign: 'center',
            color: theme.palette.greys[400],
        },
        subText: {
            padding: '8px 16px 0 16px',
            textAlign: 'center',
            color: theme.palette.greys[400],
        },
    }),
    {
        classNamePrefix: EmptyView.name,
    }
);

export default EmptyView;
